import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { formatBreadcrumbLabel } from "../utils/breadcrumbLabel";
import "./breadcrumb.css";

const Breadcrumb = ({ title, items, activeColor }) => {
  const trail = items || [{ label: "Home", to: "/home" }, { label: title }];
  const navigationRef = useRef(null);
  const trailKey = JSON.stringify(trail.map(({ label, to }) => [label, to]));

  useEffect(() => {
    const navigation = navigationRef.current;
    let frame;
    const updateScrollEdges = () => {
      navigation.dataset.scrollStart = String(navigation.scrollLeft <= 1);
      navigation.dataset.scrollEnd = String(navigation.scrollLeft + navigation.clientWidth >= navigation.scrollWidth - 1);
    };
    const revealCurrentStep = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        // Scroll only the trail, keeping the page's vertical position unchanged.
        navigation.scrollLeft = window.innerWidth < 992
          ? Math.max(0, navigation.scrollWidth - navigation.clientWidth)
          : 0;
        updateScrollEdges();
      });
    };
    revealCurrentStep();
    const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(revealCurrentStep) : null;
    observer?.observe(navigation);
    observer?.observe(navigation.firstElementChild);
    navigation.addEventListener("scroll", updateScrollEdges, { passive: true });
    window.addEventListener("resize", revealCurrentStep);
    return () => {
      window.cancelAnimationFrame(frame);
      observer?.disconnect();
      navigation.removeEventListener("scroll", updateScrollEdges);
      window.removeEventListener("resize", revealCurrentStep);
    };
  }, [trailKey]);

  return (
    <div className='breadcrumb breadcrumb--scrollable mb-0 py-26 border-bottom' style={activeColor ? { "--breadcrumb-active-color": activeColor } : undefined}>
      <div className='container container-lg'>
        <div className='breadcrumb-wrapper flex-between flex-wrap gap-16'>
          {/*<h6 className='mb-0'>{title}</h6>*/}
          <nav className="breadcrumb-nav" aria-label="Breadcrumb" ref={navigationRef}>
            <ol className='breadcrumb-trail flex-align gap-8 flex-wrap'>
              {trail.map((item, index) => {
                const current = index === trail.length - 1;
                const label = formatBreadcrumbLabel(item.label);
                return (
                  <li key={`${item.to || item.label}-${index}`} className={`breadcrumb-trail__item text-sm${current ? " breadcrumb-trail__current" : ""}`}>
                    {index > 0 && <i className='ph ph-caret-right breadcrumb-trail__separator' aria-hidden="true" />}
                    {!current && item.to ? (
                      <Link to={item.to} state={item.state} className='breadcrumb-trail__link text-gray-900 flex-align gap-8 hover-text-main-600'>
                        {index === 0 && <i className='ph ph-house' aria-hidden="true" />}
                        <span>{label}</span>
                      </Link>
                    ) : <span aria-current={current ? "page" : undefined}>{label}</span>}
                  </li>
                );
              })}
            </ol>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
